import React, { useEffect, useCallback, useState } from 'react';
import { string, bool, number, shape } from 'prop-types';

import { ProductPod } from '@thd-olt-component-react/product-pod';
import { QueryProvider } from '@thd-nucleus/data-sources';

import './SponsoredProductPod.scss';

const SponsoredProductPod = ({
  product,
  storeId,
  isDesktop,
  position,
  schema,
  pageId,
  noATCFulfillment
}) => {
  const [beacon, setBeacon] = useState('');
  const [linkBeacon, setLinkBeacon] = useState('');
  const [atcBeacon, setAtcBeacon] = useState('');
  const [atcButton, setAtcButton] = useState();
  const [isATCButtonCLickHandlerAttached, setIsATCButtonCLickHandlerAttached] = useState(false);

  useEffect(() => {
    const protocolSubstring = 'https:';
    let { onClickBeacon } = product;

    if (onClickBeacon.startsWith(protocolSubstring)) {
      onClickBeacon = onClickBeacon.slice(protocolSubstring.length);
    }

    setBeacon(onClickBeacon);
  }, [product.onClickBeacon]);

  useEffect(() => {
    const merchRec = `MERCH=REC-_-sp-_-${schema}-_-${position}-_-n/a-_-${pageId}-_-n/a-_-n/a-_-n/a`;
    /* eslint-disable-next-line */
    setLinkBeacon(`${beacon}${location.protocol}//${location.host}${product.canonicalURL}?${merchRec}&ITC=${product.ITC}`);
  }, [product, position, schema, pageId, beacon]);

  const handleProductClick = useCallback((evt) => {
    if (linkBeacon) {
      evt.preventDefault();
      window.location = linkBeacon;
    }
  }, [linkBeacon]);

  useEffect(() => {
    const redirectSubstring = '&redirect=';
    let onClickBeacon = beacon;

    if (onClickBeacon.endsWith(redirectSubstring)) {
      onClickBeacon = onClickBeacon.slice(0, -redirectSubstring.length);
    }

    setAtcBeacon(onClickBeacon);
  }, [beacon]);

  useEffect(() => {
    if (!atcButton) {
      const atcButtonSelector = `[data-product-id="${product.id}"] button[class*="add-to-cart"]`;
      setAtcButton(document.querySelectorAll(atcButtonSelector)[0]);
    }
  });

  useEffect(() => {
    if (atcButton && atcBeacon) {
      const atcButtonClickHandler = () => fetch(atcBeacon);

      if (!isATCButtonCLickHandlerAttached) {
        atcButton.addEventListener('click', atcButtonClickHandler);
        setIsATCButtonCLickHandlerAttached(true);
      }
    }
  }, [product, atcBeacon, atcButton]);

  useEffect(() => {
    const addBeaconingOnATCButtonClick = () => {
      const atcBtn = document.querySelector(`[data-product-id="${product.id}"] button[class*="add-to-cart"]`);
      if (!isATCButtonCLickHandlerAttached && atcBtn) {
        atcBtn.addEventListener('click', () => fetch(atcBeacon));
        setIsATCButtonCLickHandlerAttached(true);
      }
    };
    window.addEventListener('load', addBeaconingOnATCButtonClick);
    return () => window.removeEventListener('load', addBeaconingOnATCButtonClick);
  }, [product.id, atcBeacon, isATCButtonCLickHandlerAttached]);

  return (
    <QueryProvider cacheKey="sponsored-product-pod" dataSource="searchNav">
      <div
        data-product-id={product.id}
        data-onview-beacon={product.onViewBeacon}
        data-onclick-beacon={product.onClickBeacon}
        className={`sponsored-product-pod ${isDesktop ? 'desktop' : ''}`}

      >
        <ProductPod
          itemId={product?.id?.toString()}
          storeId={storeId}
          onClick={handleProductClick}
          brandTitleMaxLine={3}
          hideFulfillment
          hideShopThisCollection
          noATCFulfillment={noATCFulfillment}
          hideFavorites
          hideBadges
          hidePriceBadge
        />
      </div>
    </QueryProvider>
  );
};

SponsoredProductPod.propTypes = {
  storeId: string.isRequired,
  product: shape({
    id: number.isRequired,
    onClickBeacon: string.isRequired,
    onViewBeacon: string.isRequired
  }).isRequired,
  isDesktop: bool,
  position: number.isRequired,
  schema: string.isRequired,
  pageId: string.isRequired,
  noATCFulfillment: bool
};

SponsoredProductPod.defaultProps = {
  isDesktop: true,
  noATCFulfillment: null
};

export { SponsoredProductPod };
